var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("a", {
    className: "icon-link"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.211 14.211",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Account settings") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.017 6.848c.93 0 1.736-.334 2.395-.992a3.28 3.28 0 0 0 .992-2.395c0-.932-.334-1.737-.992-2.395A3.28 3.28 0 0 0 7.016.073c-.93 0-1.736.334-2.394.993A3.28 3.28 0 0 0 3.63 3.46c0 .93.334 1.737.992 2.395a3.28 3.28 0 0 0 2.395.992m5.927 4.04A8 8 0 0 0 12.83 10a7 7 0 0 0-.219-.893 4.4 4.4 0 0 0-.367-.834 3.2 3.2 0 0 0-.554-.721 2.5 2.5 0 0 0-.796-.5 2.8 2.8 0 0 0-1.015-.184c-.144 0-.283.059-.55.233q-.25.162-.574.37-.278.177-.743.327a3 3 0 0 1-.907.147 3 3 0 0 1-.908-.147 3.3 3.3 0 0 1-.741-.326L4.88 7.1c-.267-.175-.406-.234-.55-.234-.365 0-.707.062-1.015.184a2.5 2.5 0 0 0-.796.5 3.2 3.2 0 0 0-.553.721 4.5 4.5 0 0 0-.368.834 7 7 0 0 0-.218.893 8 8 0 0 0-.114.89q-.028.405-.028.83c0 .734.233 1.328.693 1.767.455.432 1.056.652 1.787.652h6.772c.732 0 1.333-.22 1.788-.652.46-.438.693-1.032.693-1.767 0-.283-.009-.563-.028-.83"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.5f0b4d492d5b082c8dc585628f5f3271.svg";
export { ForwardRef as ReactComponent };